module.exports = __webpack_public_path__ + "img/chevron-white.9163c6be.svg";